import React from "react";
import { ModalBody, ModalHeader, ModalFooter, ButtonGroup, Button, Modal } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { hotelModalDataColumns } from "./dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const NewHotelModal = ({ isOpen, updateHotelProps, deleteHotelProps, mergeHotelProps, createHotels, newHotels, isHotelCreating }) => {
  const hotelRows = newHotels || [];
  const deleteDraftHotel = index => {
    deleteHotelProps([{ prop: "newHotels." + index }]);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateHotelProps([{ prop: "isNewHotelModalOpen", value: !isOpen }]);
      }}
      className="modal-xl hotels-modal hotels-modal--composer"
    >
      <ModalHeader
        toggle={() => {
          updateHotelProps([{ prop: "isNewHotelModalOpen", value: !isOpen }]);
        }}
      >
        <div>
          <div className="hotels-modal__eyebrow">Hotel Intake</div>
          <span className="hotels-modal__title">Create Hotels</span>
          <div className="hotels-modal__helper">
            Add one or more hotel records, review them in the table, then save the batch.
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="hotels-modal__body">
        <div className="hotels-modal__summary">
          <div className="hotels-modal__summary-item">
            <span className="hotels-modal__summary-label">Batch</span>
            <span className="hotels-modal__summary-value">New hotels</span>
          </div>
          <div className="hotels-modal__summary-item">
            <span className="hotels-modal__summary-label">Rows</span>
            <span className="hotels-modal__summary-value">{hotelRows.length}</span>
          </div>
        </div>

        <div className="hotels-modal__toolbar">
          <ButtonGroup>
          <Button
            color={"faiz1"}
            onClick={() => {
              mergeHotelProps([{ prop: "newHotels", value: [{ name: "", score: 0 }] }]);
            }}
          >
            <i className={"fa fa-plus"} /> Add Hotel
          </Button>
        </ButtonGroup>
        </div>

        <div className="hotels-modal__workspace">
          <div className="hotels-modal__workspace-header">
            <div>
              <div className="hotels-modal__workspace-title">Batch Editor</div>
              <div className="hotels-modal__workspace-copy">
                Use the inline table below to enter hotel names before creating them.
              </div>
            </div>
          </div>

          <div className="hotels-modal__table-shell">
        <ReactTable
          data={hotelRows}
          columns={hotelModalDataColumns(updateHotelProps, deleteDraftHotel)}
          className="-highlight -striped hotels-table"
          defaultPageSize={5}
          filterable
        />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            // updateHotelProps([{ prop: "isNewHotelModalOpen", value: !isOpen }]);
            createHotels(newHotels);
          }}
        >
          {isHotelCreating ? (
            <>
              <Spinner size={10} animating={true} color={"white"} />
              &nbsp;
            </>
          ) : null}
          Create
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() => {
            updateHotelProps([{ prop: "isNewHotelModalOpen", value: !isOpen }, { prop: "newHotels", value: [] }]);
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default NewHotelModal;
